(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.lt = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      datepicker: {
        apply: 'Apply',
        // to be translated
        clearSelection: 'Clear selection',
        // to be translated
        pickADays: 'Select days',
        // to be translated
        now: 'Dabar',
        today: 'Šiandien',
        cancel: 'Atšaukti',
        clear: 'Vakyti',
        confirm: 'OK',
        selectDate: 'Pasirink datą',
        selectTime: 'Pasirink laiką',
        startDate: 'Data nuo',
        startTime: 'Laikas nuo',
        endDate: 'Data iki',
        endTime: 'Laikas iki',
        prevYear: 'Metai atgal',
        nextYear: 'Metai į priekį',
        prevMonth: 'Mėn. atgal',
        nextMonth: 'Mėn. į priekį',
        year: '',
        month1: 'Sausis',
        month2: 'Vasaris',
        month3: 'Kovas',
        month4: 'Balandis',
        month5: 'Gegužė',
        month6: 'Birželis',
        month7: 'Liepa',
        month8: 'Rugpjūtis',
        month9: 'Rugsėjis',
        month10: 'Spalis',
        month11: 'Lapkritis',
        month12: 'Gruodis',
        // week: 'savaitė',
        weeks: {
          sun: 'S.',
          mon: 'Pr.',
          tue: 'A.',
          wed: 'T.',
          thu: 'K.',
          fri: 'Pn.',
          sat: 'Š.'
        },
        months: {
          jan: 'Sau',
          feb: 'Vas',
          mar: 'Kov',
          apr: 'Bal',
          may: 'Geg',
          jun: 'Bir',
          jul: 'Lie',
          aug: 'Rugp',
          sep: 'Rugs',
          oct: 'Spa',
          nov: 'Lap',
          dec: 'Gruo'
        },
        pickADay: 'Select a day'
      },
      select: {
        loading: 'Kraunasi',
        noMatch: 'Duomenų nerasta',
        noData: 'Nėra duomenų',
        placeholder: 'Pasirink'
      },
      pagination: {
        goto: 'Eiti į',
        pagesize: '/p',
        total: 'Viso {total}',
        pageClassifier: ''
      },
      upload: {
        deleteTip: 'spauskite "Trinti" norėdami pašalinti',
        delete: 'Trinti',
        preview: 'Peržiūrėti',
        continue: 'Toliau'
      },
      table: {
        emptyText: 'Duomenų nerasta',
        confirmFilter: 'Patvirtinti',
        resetFilter: 'Atstatyti',
        clearFilter: 'Išvalyti',
        sumText: 'Suma'
      },
      tree: {
        emptyText: 'Nėra duomenų'
      }
    }
  };
  _exports.default = _default;
});